import { CompassOutlined, PlusOutlined } from '@ant-design/icons';
import { DatePicker, Button, Input } from 'antd';
import moment from 'moment';
import React, { ChangeEvent } from 'react';
import { Device } from '../../../../contexts/mainContext';
import { Icon as LegacyIcon } from '@ant-design/compatible';

interface ServiceListToolbarProps {
  device: Device;
  defaultDates: moment.Moment[];
  clearSearch: () => any;
  onDateUpdate: (dateA: moment.Moment, dateB: moment.Moment) => any;
  setSearchValue: (value?: string) => any;
  clearAllFilters: () => any;
  onServiceSearch: (data: string) => any;
  openMap: () => any;
  openCreateServiceDrawer: () => any;
  searchValue?: string;
  searchLoading: boolean;
  isAdmin: boolean;
}

const ServiceListToolbar: React.FC<ServiceListToolbarProps> = (
  props: ServiceListToolbarProps,
) => {
  const {
    device,
    defaultDates,
    clearSearch,
    onDateUpdate,
    isAdmin,
    searchValue,
    setSearchValue,
    searchLoading,
    clearAllFilters,
    onServiceSearch,
    openMap,
    openCreateServiceDrawer,
  } = props;

  const [pickerOpened, setPickerOpened] = React.useState(false);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        paddingBottom: '2em',
      }}
    >
      <DatePicker.RangePicker
        format={'DD/MM/YYYY'}
        size={device.type === 'phone' ? 'large' : undefined}
        renderExtraFooter={() => 'Por favor, selecciona un rango de fechas'}
        defaultValue={[defaultDates?.[0], defaultDates?.[1]]}
        value={
          !pickerOpened ? [defaultDates?.[0], defaultDates?.[1]] : undefined
        }
        ranges={{
          Hoy: [moment(), moment()],
          'Este mes': [moment().startOf('month'), moment().endOf('month')],
        }}
        onOpenChange={(open) => {
          setPickerOpened(open);
        }}
        allowClear={false}
        onChange={async ([dateA, dateB]) => {
          clearSearch();
          return onDateUpdate(dateA, dateB);
        }}
      />
      <div
        style={{
          marginLeft: '20px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
        }}
      >
        <Button
          onClick={() => {
            clearSearch();
            onDateUpdate(moment(), moment());
          }}
        >
          Hoy
        </Button>
        <Button
          onClick={() => {
            clearSearch();
            onDateUpdate(moment().add(1, 'day'), moment().add(1, 'day'));
          }}
          style={{ marginLeft: '10px' }}
        >
          Mañana
        </Button>
        <Button
          onClick={() => {
            clearSearch();
            onDateUpdate(
              moment().subtract(1, 'day'),
              moment().subtract(1, 'day'),
            );
          }}
          style={{ marginLeft: '10px', marginRight: '20px' }}
        >
          Ayer
        </Button>
        <Button
          icon={<LegacyIcon type={'close'} />}
          onClick={clearAllFilters}
          style={{ marginRight: '10px' }}
        >
          Eliminar filtros
        </Button>
        <Input.Search
          value={searchValue}
          allowClear={true}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            setSearchValue(event.target.value);
          }}
          loading={searchLoading}
          placeholder="Busca cualquier servicio"
          onSearch={onServiceSearch}
          style={{ width: '250px' }}
        />
      </div>
      <div style={{ marginLeft: 'auto' }}>
        {isAdmin && (
          <Button
            icon={<CompassOutlined translate={undefined} />}
            style={{ marginRight: '10px' }}
            onClick={openMap}
          >
            Mapa
          </Button>
        )}
        {isAdmin && process.env.NODE_ENV === 'development' && (
          <Button
            icon={<PlusOutlined translate={undefined} />}
            type={'primary'}
            onClick={openCreateServiceDrawer}
          >
            Crear servicio sin presupuesto
          </Button>
        )}
      </div>
      {/* <Dropdown disabled={!this.state.actionsEnabled} overlay={actionsMenu}>
          <Button type="primary" size="small">
            Acciones multi-servicio <Icon type="down" />
          </Button>
        </Dropdown> */}
    </div>
  );
};

export default ServiceListToolbar;
